import React from 'react';

import { trackEvent } from 'src/lib/analytics';
import { localStorage } from 'src/lib/localStorage';

import { ReactComponent as CollapseIcon } from './collapseIcon.svg';

import './Collapse.css';

export default class Collapse extends React.Component {
  constructor(props) {
    super(props);

    const key = props.persistenceKey;
    let collapsed = key ? localStorage.getItem(key) : true;
    if (typeof collapsed !== 'boolean') collapsed = true;
    this.state = { collapsed };
  }

  onCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
    if (this.props.persistenceKey) {
      localStorage.setItem(this.props.persistenceKey, !this.state.collapsed);
    }
    if (this.props.trackEventKey && this.state.collapsed) {
      trackEvent('sidebar_'.concat(this.props.trackEventKey), { action: 'expand' });
    }
  };

  render() {
    const { collapsed } = this.state;
    const { component: Component, title } = this.props;

    return (
      <div className="collapse-container">
        <div onClick={this.onCollapse} className="collapse-header">
          <div className={`collapse-header-icon ${collapsed ? 'collapsed' : 'opened'}`}>
            <CollapseIcon/>
          </div>
          <span>{title}</span>
        </div>
        {!collapsed && <div><Component/></div>}
      </div>
    );
  }
}
